import { Routes, Route } from "react-router-dom";
import { AnalyticsRouteTracker } from "@/components/AnalyticsRouteTracker";
import DashboardLayoutClient from "@/components/dashboard/DashboardLayoutClient";
import Index from "@/pages/Index";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AcceptableUsePolicy from "@/pages/AcceptableUsePolicy";
import Sla from "@/pages/Sla";
import CookiePolicy from "@/pages/CookiePolicy";
import Dpa from "@/pages/Dpa";
import TermsOfService from "@/pages/TermsOfService";
import Enrollment from "@/pages/Enrollment";
import AdminConsentCallbackPage from "@/AdminConsentCallbackPage";
import Dashboard from "@/pages/Dashboard";
import Billing from "@/pages/Billing";
import Support from "@/pages/Support";
import SettingsPage from "@/pages/SettingsPage";
import StorageAnalytics from "@/pages/StorageAnalytics";
import Tenants from "@/pages/Tenants";
import TenantDetail from "@/pages/TenantDetail";
import Admin from "@/pages/Admin";
import SyncMonitoring from "@/pages/SyncMonitoring";
import SynchronizationPage from "@/pages/SynchronizationPage";
import SovereignContinuity from "@/pages/SovereignContinuity";
import NotFound from "@/NotFound";
import Event from "./pages/Event";
import Book from "./pages/Book";
import LivePresentation from "./pages/LivePresentation";

function DashboardLayout() {
  return (
    <DashboardLayoutClient>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="billing" element={<Billing />} />
        <Route path="support" element={<Support />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="storage" element={<StorageAnalytics />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="tenants/:id" element={<TenantDetail />} />
        <Route path="admin" element={<Admin />} />
        <Route path="sync" element={<SyncMonitoring />} />
        <Route path="synchronization" element={<SynchronizationPage />} />
      </Routes>
    </DashboardLayoutClient>
  );
}

export default function App() {
  return (
    <>
      <AnalyticsRouteTracker />
      <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/aup" element={<AcceptableUsePolicy />} />
      <Route path="/sla" element={<Sla />} />
      <Route path="/cookies" element={<CookiePolicy />} />
      <Route path="/dpa" element={<Dpa />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/enrollment" element={<Enrollment />} />
      <Route path="/enrollment/admin-consent-callback" element={<AdminConsentCallbackPage />} />
      <Route path="/dashboard/*" element={<DashboardLayout />} />
      <Route path="/sovereign-continuity" element={<SovereignContinuity />} />
      <Route path="/event" element={<Event />} />
      <Route path="/live" element={<LivePresentation />} />
      <Route path="/book" element={<Book />} />
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  );
}
